import { createEventBus } from "~/utils/miscellaneous";

export default createEventBus();